import { useState } from 'react'

export function Card ({ name, mount, form, shop, setShop, ID, inven, setInven }) {
  const [Mount, setMount] = useState(mount)

  const DeleteIng = () => {
    const newShop = shop
    const newInven = []
    inven.forEach(element => {
      if (element.id !== ID) {
        newInven.push(element)
      } else {
        newShop.push(element)
      }
    })

    setShop(newShop)
    setInven(newInven)
  }

  const AddMount = () => {
    let newMount
    if (form === 'g') {
      newMount = Mount + 50
    } else if (form === 'ml') {
      newMount = Mount + 100
    } else if (form === 'unidades') {
      newMount = Mount + 1
    } else if (form === 'cdta') {
      newMount = Mount + 1
    }
    setMount(newMount)
    console.log(Mount)

    const newInven = []
    inven.forEach(element => {
      if (element.id === ID) {
        const newElement = element
        newElement.mount = newMount + 0
        newInven.push(newElement)
      } else {
        newInven.push(element)
      }
    })
    setInven(newInven)
  }

  const LessMount = () => {
    let newMount
    if (form === 'g') {
      newMount = Mount - 50
    } else if (form === 'ml') {
      newMount = Mount - 100
    } else if (form === 'unidades') {
      newMount = Mount - 1
    } else if (form === 'cdta') {
      newMount = Mount - 1
    }
    setMount(newMount)

    const newInven = []
    inven.forEach(element => {
      if (element.id === ID) {
        const newElement = element
        newElement.mount = newMount + 0
        newInven.push(newElement)
      } else {
        newInven.push(element)
      }
    })
    setInven(newInven)
  }

  return (
    <section className='flex w-full min-h-16 justify-between items-center bg-[#313131] border-2 border-[#434343] rounded-xl'>
      <div className='flex w-11/12 gap-2 items-center'>

              <img className='h-16 rounded-[0.50rem]' src="./LogoP.png" alt="" />
              <div className='flex flex-col gap-1 w-3/6 ml-3'>
                <h6 className='max-[1280px]:text-lg font-semibold w-full text-base text-[#E3E3E3]'>{ name }</h6>

                <div className="flex items-center gap-1 h-fit">
                  <button onClick={LessMount} className="text-xl max-[1280px]:text-4xl font-bold flex items-center justify-center h-5">-</button>
                  <p className=' max-[1280px]:text-base text-right text-[#909090]'>{ Mount } { form }</p>
                  <button onClick={AddMount} className="text-xl max-[1280px]:text-4xl font-bold flex items-center justify-center h-5">+</button>
                </div>

              </div>
      </div>

              <button onClick={DeleteIng} className='w-8 h-8 rounded-full bg-orange-600 border-[#575757] mr-2.5'>X</button>
            </section>
  )
}
